import { render, staticRenderFns } from "./req-restore-password-form.vue?vue&type=template&id=42711479"
import script from "./req-restore-password-form.vue?vue&type=script&lang=js"
export * from "./req-restore-password-form.vue?vue&type=script&lang=js"
import style0 from "./req-restore-password-form.vue?vue&type=style&index=0&id=42711479&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports